<template>
	<header class="header">
		<router-link :to="{ name: 'home' }" class="header__logo"
			:style="{ backgroundImage: logo }">
		</router-link>
		<stepper v-if="hasSteppers" :value="step" :steps="steps" />
		<a-button
			v-show="hasBackButton"
			class="header__button"
			secondary
			@click="$router.go(-1)"
		>
			{{ $t("back") }}
		</a-button>
		<a-button
			v-show="hasGettingStartedButton"
			:to="{ name: 'survey' }"
			class="header__button"
		>
			{{ $t("start") }}
		</a-button>
	</header>
</template>

<script>
import Stepper from "@/components/Stepper";
import {
	HeaderType,
	STEPPER_HEADER,
	CONTACT_PAGE_HEADER,
	PRIVACY_POLICY_HEADER,
	GETTING_STARTED_HEADER
} from "@/headerType";
import survey from "@/survey";
import store from "@/store";
import aButton from "@/components/Button";

export default {
	name: "AHeader",
	components: {
		Stepper,
		aButton
	},
	props: {
		hasStepper: {
			type: Boolean,
			default: true
		},
		step: {
			type: Number,
			required: true
		},
		type: {
			type: HeaderType,
			required: true
		}
	},
	data() {
		return {
			currentStep: 3
		};
	},
	computed: {
		hasSteppers() {
			return this.type === STEPPER_HEADER;
		},
		hasContactLink() {
			return this.type === CONTACT_PAGE_HEADER;
		},
		hasBackButton() {
			return this.type === PRIVACY_POLICY_HEADER;
		},
		hasGettingStartedButton() {
			return this.type === GETTING_STARTED_HEADER;
		},
		steps() {
			return survey.categories.map(e => e.name);
		},
		logo() {
			return `url(${store.state.tenant.logo})`
		}
	},
	i18n: {
		messages: {
			en: {
				back: "Back to previous page",
				start: "Start quick scan"
			},
			nl: {
				back: "Terug naar de vorige pagina",
				start: "Start de scan"
			}
		}
	}
};
</script>

<style>
.header {
	display: flex;
	width: 100%;
	max-width: 1200px;
	margin: 30px auto 35px;
	justify-content: space-between;
	align-items: center;
}
@media only screen and (max-width: 1300px) {
	.header {
		margin: 30px 50px 35px;
		width: calc(100% - 100px);
	}
}

.header__logo {
	width: 400px;
	height: 100px;
	background-size: contain;
    background-position: left;
}
.header__logo-title {
	margin-left: 10px;
	font-size: 30px;
	color: #0084a4;
}

.header__logo-text {
	font-size: 16px;
	margin-top: 10px;
	color: #808080;
	white-space: nowrap;
}

.header__logo-text--link {
	text-decoration: none;
	color: #0084a4;
}

.header__logo-text--link:hover {
	text-decoration: underline;
	color: #0084a4;
}

@media only screen and (max-width: 767px) {
	.header {
		margin: 10px 25px 10px;
		width: calc(100% - 50px);
		justify-content: center;
	}

	.header__logo {
		width: 260px;
		background-position: center;
		height: 65px;
	}

	.header__contact {
		display: none !important;
	}

	.header__logo-text {
		display: none;
	}

	.header__logo-img {
		width: initial;
	}

	.header__logo-title {
		font-size: 24px;
	}

	.header__button {
		display: none;
	}
}
</style>
